/*
* This is a rewrite of django-react-csrftoken.
* It stopped working in IE.
* and also had 2 unnecessary dependencies.
* and also never needed to exist in the first place.
* */

import React from 'react';
import { getCookie } from '../utils';

export default function DjangoCSRFToken() {
    return (
        <input
            type="hidden"
            name="csrfmiddlewaretoken"
            value={ getCookie('csrftoken') }
        />
    );
}
